import COMBaseRegulation from "../com_base_regulation";
import {Check, TimeSpan} from "@sparkware/app-utils";
import TempAccountMessageRegulationHelper from "../../../helpers/temp_account_message_helper";

interface AccountData {
  IdVerificationStatus: number,
  AddressVerificationStatus: number,
  RealityCheckDataIntervalInMins: number
}

export default class MaltaRegulation extends COMBaseRegulation {
  static CLASS = 'MaltaRegulation';

  protected realityCheckEnabled(): boolean {
    return true;
  }

  showTempAccountMessage() {
    TempAccountMessageRegulationHelper.create({
      serviceFactory: this.serviceFactory
    }).showTempAccountMessage({
      messageKey: 'gib_temp_account_message'
    });
  }

  private _getAccountData(): AccountData {
    return this.serviceFactory.userService().getAccountData() as AccountData;
  }

  sessionTimerEnabled() {
    return this.getRealityCheckInterval().totalMilliseconds > 0;
  }

  getRealityCheckInterval(): TimeSpan {
    if (this.serviceFactory.skinService().useControlCenterForReminderInterval()) {
      const accountData = this._getAccountData();
      if (!Check.isNullOrUndefined(accountData?.RealityCheckDataIntervalInMins)) {
        return TimeSpan.fromMinutes(accountData.RealityCheckDataIntervalInMins);
      }
    }
    return TimeSpan.fromMilliseconds(0);
  }

  async _handleRealityCheckMessage(sessionTimer): Promise<void> {
    const isGameRunning = await this.serviceFactory.gameService().isGameRunning();

    this.serviceFactory.userService().getRealityCheckData().then(data => {

      this.serviceFactory.gameService().stopCurrentGameAutoplay();

      this.serviceFactory.orbitComponentRenderService().showTimeSpentReminderWithBalance({
        playingTime: this.getCurrentSessionTime(),
        totalNetLoss: Check.isNullOrUndefined(data?.TotalNetLoss) ? 0 : data.TotalNetLoss,
        isInGame: isGameRunning,
        amountWagered: Check.isNullOrUndefined(data?.WagerAmount) ? 0 : data.WagerAmount,
        subtitle: "TSR_SUBTITLE_MALTA"
      });

    }).catch(err => {

      this.serviceFactory.gameService().stopCurrentGameAutoplay();

      this.serviceFactory.orbitComponentRenderService().showTimeSpentReminderWithBalance({
        playingTime: this.getCurrentSessionTime(),
        totalNetLoss: 0,
        isInGame: isGameRunning,
        amountWagered: 0,
        subtitle: "TSR_SUBTITLE_MALTA"
      });
    });

  }
}
